import { render, staticRenderFns } from "./ScreenSolinfaFacturas.vue?vue&type=template&id=af1a001e"
import script from "./ScreenSolinfaFacturas.vue?vue&type=script&lang=js"
export * from "./ScreenSolinfaFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports